<template>
  <VLayout
    :title="$t('doctordata.doctordata')"
    :showButtonReturn="true"
    :showButtonHome="true"
  >
    <DoctorDataForm />
  </VLayout>
</template>

<script>
import VLayout from "@/layouts/Default";
import DoctorDataForm from "@/components/DoctorDataForm";

export default {
  components: {
    VLayout,
    DoctorDataForm,
  },
  fallbackI18n: {
    messages: {
      und: {
        doctordata: {
          doctordata: "Doctor Data",
        },
      },
    },
  },
};
</script>
